import type { Except } from "type-fest";

import { useMenu } from "./MenuContext";

export const MenuButton: React.FC<
  Except<React.ComponentProps<"button">, "onClick">
> = (props) => {
  const { toggleMenu, isMenuOpen, setIsTooltipHidden } = useMenu();
  return (
    <button
      {...props}
      onClick={toggleMenu}
      onMouseLeave={() => {
        setIsTooltipHidden(false);
      }}
      onMouseEnter={() => {
        if (isMenuOpen) {
          setIsTooltipHidden(true);
        }
      }}
    />
  );
};
